import { esc } from './formatters';

/**
 * Removable chip of the transaction area filter (`obszar`). The filter only
 * arrives in the address of the map, so the server names the area once
 * (`data-area-label`); without a name the chip shows the PRG code.
 */
export function areaFilterChipHtml(areaCode, areaLabel) {
    if (!areaCode) {
        return '';
    }
    var label = 'Obszar: ' + (areaLabel || areaCode);
    return '<span class="nm-active-filters__label">Wybrane filtry</span><div class="nm-active-filters__scroller">'
        + '<span class="nm-active-filter"><span>' + esc(label) + '</span>'
        + '<button type="button" data-transaction-active-clear="obszar" aria-label="' + esc('Usuń filtr ' + label) + '">×</button>'
        + '</span></div>';
}
